import React, { useState } from "react";
import img1 from "../../assets/img/projects/img1.png";
import img2 from "../../assets/img/projects/img2.png";
import img3 from "../../assets/img/projects/img3.png";
import article from "../../assets/icons/article.svg";
import slideshow from "../../assets/icons/slideshow.svg";
import AnimatedPopup from "../common/AnimatedPopup";
import VideoPlayer from "../common/VideoPlayer";
import document from "../../assets/img/projects/document.png";

export default function ProjectsGrid({ searchQuery }) {
  const data = [
    {
      title: "Nuclear Power Plant",
      img: img1,
      article: true,
      slideshow: true,
      url: true,
    },
    {
      title: "Nuclear Power Plant",
      img: img2,
      url: true,
    },
    {
      title: "화력발전소 홍보영상",
      img: img3,
      slideshow: true,
    },
    {
      title: "Nuclear Power Plant",
      img: img1,
      article: true,
      slideshow: true,
      url: true,
    },
  ];

  const [openDocumentPopup, setOpenDocumentPopup] = useState(false);
  const [openVideoPopup, setOpenVideoPopup] = useState(false);
  return (
    <div>
      <div className="grid grid-cols-1  lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-[30px] 2xl:gap-y-[70px] gap-y-10">
        {[...data, ...data].map((project, idx) => (
          <div key={idx} className="flex flex-col gap-[17px] ">
            <h2 className="text-white text-[20px] font-bold whitespace-nowrap text-ellipsis line-clamp-1">
              {project.title}
            </h2>
            <div className="overflow-hidden bg-[#323649] rounded-[16px] shadow-[0_20px_40px_0_rgba(15,_17,_26,_0.20)] flex-1">
              <img
                src={project.img}
                alt=""
                className="w-full aspect-[378/250] "
              />

              {/* text content  */}
              <div className="p-5 flex flex-col gap-10">
                {/* table  */}
                <table className="text-[14px] leading-[171%] font-normal">
                  <tbody>
                    <tr>
                      <td className="text-[#8E98C7] text-justify pb-1.5">
                        프로젝트명
                      </td>
                      <td className="text-white  pl-2.5 pb-1.5">
                        Nuclear Power Plant{" "}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-[#8E98C7] text-justify pb-1.5">
                        기 술 타 입
                      </td>
                      <td className="text-white  pl-2.5 pb-1.5">
                        Web, Walkinside{" "}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-[#8E98C7] text-justify pb-1.5">
                        발 주 처
                      </td>
                      <td className="text-white  pl-2.5 pb-1.5">
                        한국수력원자력
                      </td>
                    </tr>

                    <tr>
                      <td className="text-[#8E98C7] text-justify ">기 간</td>
                      <td className="text-white  pl-2.5">
                        2020-01-01 ~ 2025-12-31{" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* action  */}
                <div className="flex items-center justify-end gap-5">
                  {project.article && (
                    <button
                      onClick={() => setOpenDocumentPopup(true)}
                      className="rounded-[10px] bg-black/30 flex items-center justify-center w-[42px] aspect-square"
                    >
                      <img src={article} alt="" />
                    </button>
                  )}
                  {project.url && (
                    <button className="rounded-[10px] bg-black/30 flex items-center justify-center w-[42px] aspect-square text-[#E96F0C] roboto-font text-[14px] font-normal">
                      URL
                    </button>
                  )}
                  {project.slideshow && (
                    <button
                      onClick={() => setOpenVideoPopup(true)}
                      className="rounded-[10px] bg-black/30 flex items-center justify-center w-[42px] aspect-square"
                    >
                      <img src={slideshow} alt="" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Document popup  */}
      <AnimatedPopup
        label="연관 문서"
        isOpen={openDocumentPopup}
        onClose={() => setOpenDocumentPopup(false)}
        className="max-w-full"
        showHeader={false}
        rounded="rounded-none"
        padding="p-0"
      >
        <div className="obejt-cover w-full relative h-screen overflow-y-auto">
          <img
            src={document}
            className="w-fit max-w-[1030px] mx-auto "
            alt=""
          />
          <button
            onClick={() => setOpenDocumentPopup(false)}
            className=" text-[#242424] bg-[#D9D9D9] rounded-[10px] w-10 aspect-square  transition fixed top-4 right-4 sm:top-5 sm:right-5 flex items-center justify-center leading-[100%]"
            aria-label="Close popup"
          >
            ✕
          </button>
        </div>
      </AnimatedPopup>
      {/* Document popup  */}
      <AnimatedPopup
        label="연관 동영상"
        isOpen={openVideoPopup}
        onClose={() => setOpenVideoPopup(false)}
        className="max-w-full"
        showHeader={false}
        rounded="rounded-none"
        padding="p-0"
      >
        <div className=" obejt-cover w-full relative h-screen ">
          <VideoPlayer />
          <button
            onClick={() => setOpenVideoPopup(false)}
            className=" text-[#242424] bg-[#D9D9D9] rounded-[10px] w-10 aspect-square  transition absolute top-4 right-4 sm:top-5 sm:right-5 flex items-center justify-center leading-[100%]"
            aria-label="Close popup"
          >
            ✕
          </button>
        </div>
      </AnimatedPopup>
    </div>
  );
}
